import { Component } from 'react';

export default class ErrorBoundary extends Component {
  state = { error: null, info: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
    this.setState({ info });
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          minHeight: '100dvh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
          background: 'var(--black, #0A0A0A)',
          textAlign: 'center',
          gap: '1rem',
        }}>
          <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '2.5rem', color: 'var(--gold, #C9A84C)' }}>✦</div>
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '1.5rem', fontWeight: 400, color: '#fff', margin: 0 }}>
            Quelque chose s'est mal passé
          </h2>
          <p style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.4)', maxWidth: 320, lineHeight: 1.6, margin: 0 }}>
            Une erreur inattendue s'est produite. Rechargez la page ou revenez à l'accueil.
          </p>
          {process.env.REACT_APP_ENV !== 'production' && this.state.error?.message && (
            <pre style={{ fontSize: '0.65rem', color: '#E07070', background: 'rgba(224,112,112,0.08)', border: '1px solid rgba(224,112,112,0.2)', borderRadius: 6, padding: '0.6rem 0.8rem', maxWidth: 360, overflow: 'auto', textAlign: 'left', margin: 0 }}>
              {this.state.error.message}
            </pre>
          )}
          <div style={{ display: 'flex', gap: '0.6rem', flexWrap: 'wrap', justifyContent: 'center' }}>
            <button
              onClick={() => window.location.reload()}
              style={{ padding: '0.65rem 1.2rem', background: 'linear-gradient(135deg,#C9A84C,#B8922A)', border: 'none', color: '#0A0A0A', fontFamily: 'Outfit', fontSize: '0.8rem', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', cursor: 'pointer', borderRadius: 4 }}
            >
              Recharger
            </button>
            <button
              onClick={() => { this.setState({ error: null, info: null }); window.history.pushState({}, '', '/discover'); window.dispatchEvent(new PopStateEvent('popstate')); }}
              style={{ padding: '0.65rem 1.2rem', background: 'none', border: '1px solid rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.6)', fontFamily: 'Outfit', fontSize: '0.8rem', cursor: 'pointer', borderRadius: 4 }}
            >
              Retour à l'accueil
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
